<template>
  <button
    :type="type"
    :class="buttonClasses"
    :disabled="disabled || loading"
    @click="handleClick"
  >
    <span v-if="loading" class="ui-btn__spinner" />
    <slot v-else>{{ label }}</slot>
  </button>
</template>

<script>
export default {
  name: "MyButton",
  props: {
    label: {
      type: String,
      default: "",
    },
    // 'primary' | 'secondary' | 'ghost' | 'danger'
    variant: {
      type: String,
      default: "primary",
    },
    block: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "button",
    },
  },
  computed: {
    buttonClasses() {
      return {
        "ui-btn": true,
        "text-link": true,
        [`ui-btn--${this.variant}`]: true,
        "ui-btn--block": this.block,
        "ui-btn--loading": this.loading,
      };
    },
  },
  methods: {
    handleClick(event) {
      if (!this.disabled && !this.loading) {
        this.$emit("click", event);
      }
    },
  },
};
</script>

<style scoped>
.ui-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 24px;
  height: 40px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.2px;
  cursor: pointer;
  outline: none;
  user-select: none;
  transition: background-color 0.18s ease, opacity 0.18s ease,
    transform 0.1s ease;
  box-sizing: border-box;
}

.ui-btn--block {
  width: 100%;
}

/* Primary */
.ui-btn--primary {
  background-color: var(--ui-primary);
  color: #ffffff;
}
.ui-btn--primary:hover:not(:disabled) {
  background-color: #253490;
}
.ui-btn--primary:active:not(:disabled) {
  background-color: #1e2b7a;
  transform: scale(0.99);
}

/* Secondary — outlined */
.ui-btn--secondary {
  background-color: transparent;
  color: #2d3f9c;
  border: 1.5px solid #2d3f9c;
}
.ui-btn--secondary:hover:not(:disabled) {
  background-color: rgba(45, 63, 156, 0.06);
}
.ui-btn--secondary:active:not(:disabled) {
  background-color: rgba(45, 63, 156, 0.12);
}

/* Ghost */
.ui-btn--ghost {
  background-color: transparent;
  color: #2d3f9c;
}
.ui-btn--ghost:hover:not(:disabled) {
  background-color: rgba(45, 63, 156, 0.06);
}

/* Danger */
.ui-btn--danger {
  background-color: #e03131;
  color: #ffffff;
}
.ui-btn--danger:hover:not(:disabled) {
  background-color: #c92a2a;
}
.ui-btn--danger:active:not(:disabled) {
  background-color: #b52424;
  transform: scale(0.99);
}

/* Disabled */
.ui-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  pointer-events: none;
}

/* Loading spinner */
.ui-btn__spinner {
  width: 20px;
  height: 20px;
  border: 2.5px solid rgba(255, 255, 255, 0.35);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: ui-spin 0.7s linear infinite;
  flex-shrink: 0;
}

@keyframes ui-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
